export default [
  // {
  //   path: "/index",
  //   component: () => import("@/views/whitelist/index.vue"),
  //   name: "WhitelistManagement",
  //   meta: {
  //     title: "Whitelist",
  //     icon: "tn-daiban",
  //     noCache: true,
  //     affix: true
  //   }
  // },
  // {
  //   path: "/addPage",
  //   hidden: true,
  //   component: () => import("@/views/whitelist/addPage.vue"),
  //   name: "AddPage",
  //   meta: { title: "Add users", icon: "tn-daiban", noCache: true, affix: true }
  // },
  // {
  //   path: "/airdropPlan",
  //   component: () => import("@/views/airdropPlan/index.vue"),
  //   name: "AirdropPlan",
  //   meta: {
  //     title: "Airdrop Plan",
  //     icon: "tn-daiban",
  //     noCache: true,
  //     affix: true
  //   }
  // },
  // {
  //   path: "airdropPlan/detail/:id",
  //   component: () => import("@/views/airdropPlan/detail.vue"),
  //   name: "AirdropPlanDetail",
  //   meta: {
  //     title: "Airdrop Plan Detail",
  //     icon: "tn-daiban",
  //     noCache: true
  //   },
  //   hidden: true
  // },
  // {
  //   path: "airdropPlan/add",
  //   component: () => import("@/views/airdropPlan/add.vue"),
  //   name: "AddAirdropPlan",
  //   meta: { title: "Add Airdrop Plan", icon: "tn-daiban", noCache: true },
  //   hidden: true
  // }

  // {
  //   path: '/whitelistChangeProposal',
  //   component: () => import('@/views/changeProposal/index.vue'),
  //   name: 'WhitelistChangeProposal',
  //   meta: { title: 'Whitelist Change Proposal', icon: 'tn-daiban', noCache: true, affix: true },
  // }
];
